import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * Utility per combinare classi Tailwind
 * Combina clsx e tailwind-merge per gestire conflitti di classi
 */
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
